import React, {useEffect, useRef, useState} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import img2 from "../Accests/cas.jpg";
import img3 from "../Accests/s1.jpg";

import pp from "../Accests/pp.jpg";
import ppp from "../Accests/ppp.jpg";
import p1 from "../Accests/p3.jpg";
import p2 from "../Accests/p2.jpg";




import {AboutUs} from "./Aboutus";
import OurActivity from "./OurActivity";
import Owner from "./Owner";
import Contact from "./Contact";
import BottomActionBar from "./BottomActionBar";

const Home = () => {

    const [showActionBar, setShowActionBar] = useState(true);
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setShowActionBar(currentScrollY < lastScrollY);
            lastScrollY = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);



    const homeRef = useRef(null);
    const aboutRef = useRef(null);
    const galleryRef = useRef(null);
    const testimonialsRef = useRef(null);

    const scrollToSection = (section) => {
        switch (section) {
            case "home":
                homeRef.current?.scrollIntoView({ behavior: "smooth" });
                break;
            case "about":
                aboutRef.current?.scrollIntoView({ behavior: "smooth" });
                break;
            case "gallery":
                galleryRef.current?.scrollIntoView({ behavior: "smooth" });
                break;
            case "testimonials":
                testimonialsRef.current?.scrollIntoView({ behavior: "smooth" });
                break;
            default:
                console.warn(`Unknown section: ${section}`);
        }
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    return (
        <div>
            {/* Navbar */}
            <nav className="fixed top-0 left-0 w-full bg-gray-800 text-white p-4 z-10 shadow-md">
                <ul className="flex space-x-6 justify-center text-sm md:text-base font-medium">
                    <li>
                        <button onClick={() => scrollToSection("home")} className="hover:text-yellow-300">
                            Home
                        </button>
                    </li>
                    <li>
                        <button onClick={() => scrollToSection("about")} className="hover:text-yellow-300">
                            About Us
                        </button>
                    </li>
                    <li>
                        <button onClick={() => scrollToSection("gallery")} className="hover:text-yellow-300">
                            Gallery
                        </button>
                    </li>
                    <li>
                        <button onClick={() => scrollToSection("testimonials")} className="hover:text-yellow-300">
                            Testimonials
                        </button>
                    </li>
                </ul>
            </nav>

            <BottomActionBar visible={showActionBar} />

            {/* Home Section with Slider */}
            <section ref={homeRef} className="pt-16">
                <div className="relative w-full h-screen">
                    <Slider {...settings}>

                        <div className="w-full h-screen">
                            <img src={img2} alt="Slide 2" className="w-full h-full object-cover"/>
                        </div>
                        <div className="w-full h-screen">
                            <img src={img3} alt="Slide 3" className="w-full h-full object-cover"/>
                        </div>

                        <div className="w-full h-screen">
                            <img src={pp} alt="Slide 4" className="w-full h-full object-cover"/>
                        </div>
                        <div className="w-full h-screen">
                            <img src={ppp} alt="Slide 4" className="w-full h-full object-cover"/>
                        </div>
                        <div className="w-full h-screen">
                            <img src={p1} alt="Slide 4" className="w-full h-full object-cover"/>
                        </div>
                        <div className="w-full h-screen  ">
                            <img src={p2} alt="Slide 4" className="w-full h-full object-cover rounded-lg"/>
                        </div>
                    </Slider>
                    <div
                        className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent flex items-center justify-center text-white p-4">
                    <div className="text-center">
                            <h1 className="text-4xl md:text-6xl font-bold mb-4">
                                Welcome to No Limit Tour Randombe
                            </h1>
                            <p className="text-lg md:text-xl mt-4 max-w-2xl mx-auto">
                                Explore the best destinations around the world. Your adventure starts here.
                            </p>
                        </div>
                    </div>
                </div>
            </section>


            <AboutUs/>
            <OurActivity/>


            <Owner/>
            <Contact/>

        </div>
    );
};

export default Home;
